"use strict";
// based on shaka.net.HttpPluginUtils
Object.defineProperty(exports, "__esModule", { value: true });
function makeResponse(shaka, headers, data, status, uri, responseURL, requestType) {
    if (status >= 200 && status <= 299 && status !== 202) {
        // Most 2xx HTTP codes are success cases.
        if (responseURL) {
            uri = responseURL;
        }
        var response = {
            uri: uri,
            data: data,
            headers: headers,
            fromCache: !!headers['x-shaka-from-cache']
        };
        return response;
    }
    else {
        var responseText = '';
        var severity = (status === 401 || status === 403) ?
            shaka.util.Error.Severity.CRITICAL :
            shaka.util.Error.Severity.RECOVERABLE;
        throw new shaka.util.Error(severity, shaka.util.Error.Category.NETWORK, shaka.util.Error.Code.BAD_HTTP_STATUS, uri, status, responseText, headers, requestType);
    }
}
exports.default = makeResponse;
//# sourceMappingURL=makeResponse.js.map